export default __webpack_public_path__ + "static/media/1517.dfbc2cca.png";